import { render } from "./viewContract.vue?vue&type=template&id=23abd6de&scoped=true"
import script from "./viewContract.vue?vue&type=script&lang=js"
export * from "./viewContract.vue?vue&type=script&lang=js"

import "./viewContract.vue?vue&type=style&index=0&id=23abd6de&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23abd6de"]])

export default __exports__